import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const submitContact = (data) => axios.post(`${API}/contact`, data);
export const subscribeNewsletter = (email) => axios.post(`${API}/newsletter`, { email });
export const getSubstackPosts = () => axios.get(`${API}/substack`);
export const getPublicEvents = () => axios.get(`${API}/events`);

const adminClient = (token) =>
  axios.create({
    baseURL: API,
    headers: { "X-Admin-Token": token },
  });

export const adminApi = {
  me: (token) => adminClient(token).get(`/admin/me`),
  messages: (token) => adminClient(token).get(`/admin/messages`),
  subscribers: (token) => adminClient(token).get(`/admin/subscribers`),
  events: (token) => adminClient(token).get(`/admin/events`),
  createEvent: (token, data) => adminClient(token).post(`/admin/events`, data),
  deleteEvent: (token, id) => adminClient(token).delete(`/admin/events/${id}`),
};
